import React from 'react';
import {
  TextCustom,
  TextAppearance,
  TextSize,
  TextLineHeight,
  TextColor,
  TextWeight,
} from '@vw-marketing/us-components';

interface CommentWriterProps {
  writer: string;
}
export const CommentWriter: React.FC<CommentWriterProps> = props => (
  <TextCustom
    appearance={TextAppearance.headline200}
    style={{
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
      color: TextColor.primary,
      fontWeight: TextWeight.bold,
    }}
  >
    <span className="notranslate">{props.writer}</span>
  </TextCustom>
);
